var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, isRef as _isRef, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import EInputPhone from '@common/ui/EInputPhone/EInputPhone.vue';
import { useField } from 'vee-validate';
import { ref, toRef } from 'vue';
export default /*#__PURE__*/ _defineComponent(__assign({
    inheritAttrs: false
}, { __name: 'EInputPhoneField', props: {
        name: {},
        theme: {},
        size: {},
        id: {},
        disabled: { type: Boolean },
        readonly: { type: Boolean },
        label: {},
        defaultCountryCode: {},
        inputWithoutValue: { type: Boolean },
        fitWidth: { type: Boolean }
    }, emits: ["focus", "blur", "change", "input"], setup: function (__props, _a) {
        var _this = this;
        var __expose = _a.expose, __emit = _a.emit;
        var eInputPhoneRef = ref();
        var props = __props;
        var emit = __emit;
        var name = toRef(props, 'name');
        var handleChange = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        emit('change', e);
                        handleChangeField(e);
                        return [4 /*yield*/, validate()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var handleInput = function (e) {
            emit('input', e);
        };
        var _b = useField(name, undefined, {
            syncVModel: true,
            validateOnMount: false,
            validateOnValueUpdate: false,
        }), inputValue = _b.value, handleChangeField = _b.handleChange, handleBlur = _b.handleBlur, validate = _b.validate;
        var focus = function () {
            var _a;
            (_a = eInputPhoneRef.value) === null || _a === void 0 ? void 0 : _a.focus();
        };
        var blur = function () {
            var _a;
            (_a = eInputPhoneRef.value) === null || _a === void 0 ? void 0 : _a.blur();
        };
        __expose({
            focus: focus,
            blur: blur,
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(EInputPhone, _mergeProps(_ctx.$attrs, {
                id: _ctx.id,
                ref_key: "eInputPhoneRef",
                ref: eInputPhoneRef,
                modelValue: _unref(inputValue),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(inputValue) ? (inputValue).value = $event : null); }),
                "default-country-code": _ctx.defaultCountryCode,
                disabled: _ctx.disabled,
                "fit-width": _ctx.fitWidth,
                "input-without-value": _ctx.inputWithoutValue,
                label: _ctx.label,
                name: name.value,
                readonly: _ctx.readonly,
                size: _ctx.size,
                theme: _ctx.theme,
                onBlur: _unref(handleBlur),
                onChange: handleChange,
                onFocus: _cache[1] || (_cache[1] = function ($event) { return (_ctx.$emit('focus')); }),
                onInput: handleInput
            }), {
                inputAppend: _withCtx(function () { return [
                    _renderSlot(_ctx.$slots, "append")
                ]; }),
                _: 3
            }, 16, ["id", "modelValue", "default-country-code", "disabled", "fit-width", "input-without-value", "label", "name", "readonly", "size", "theme", "onBlur"]));
        };
    } }));
